import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { ICompanyMastDropdown, IBranchMastDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { ILogin } from "../../../models/Login";
import { JVInput } from "../../../shared/JVInput";

interface IINActivePOCReports {
    fromDate?: Date | null,
    // toDate?: Date | null,
    prime_Vendor?: string | null,
    company_ID?: number | null,
    branch_ID?: number | null,
    salesManager_ID?: number | null,
    vendor_Company_ID?: number | null,
    contact_Person_ID?: number | null,
    contact_Person_Name?: string | null
}

export const EmptyPrimeVendorPerformanceReports: IINActivePOCReports = {
    fromDate: null,
    // toDate: null,
    prime_Vendor: "",
    company_ID: null,
    branch_ID: null,
    salesManager_ID: null,
    vendor_Company_ID: null,
    contact_Person_Name:""
}

interface Iprops {

    salEffFilter: IINActivePOCReports,
    setSalEffFilter: (salEffFilter: IINActivePOCReports) => void,

}

export const Filter = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();

    const { control, handleSubmit, reset, watch } = useForm<IINActivePOCReports>({
        defaultValues: EmptyPrimeVendorPerformanceReports,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const inActivePOC = [{ label: "--Select--", value: "0" },
    { label: "PO", value: 1 },
    { label: "ECI", value: 2 },
    { label: "ECS", value: 3 },
    { label: "SUB", value: 4 },
    ]

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }



    useEffect(() => {
        loadCompanies();
        loadBranches();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company_ID") {
                if (value.company_ID != 0) {
                    loadBranches(value.company_ID);
                } else {
                    loadBranches();
                    if (value.branch_ID != 0) {
                    } else {
                    }
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const searchToDB = async (body: IINActivePOCReports) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptyPrimeVendorPerformanceReports;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSalEffFilter(body);
    }

    function onSubmit(data: IINActivePOCReports) {
        let newDate = new Date;
        if (data.fromDate?.toDateString() !== newDate.toDateString() || (data.prime_Vendor !== null && data.prime_Vendor !== "") || (data.company_ID !== null && data.company_ID !== 0) || (data.branch_ID !== null && data.branch_ID !== 0) || (data.salesManager_ID !== null && data.salesManager_ID !== 0) || (data.vendor_Company_ID !== null && data.vendor_Company_ID !== 0)) {
        }
        searchToDB(data);
    }


    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate column={6} label="From Date" control={control} name="fromDate" />
            <JVInput column={6} label="Prime Vendor:" control={control} name="prime_Vendor" placeholder="Enter Prime Vendor" />
            <JVInput column={6} label="POC" control={control} name="contact_Person_Name" placeholder="Enter Contact Person" />
            <JVDropdown column={6} label='Inactive Type' name='inActiveType' control={control} options={inActivePOC} optionLabel='label' optionValue='value' placeholder='-- Select Type --' />
            {(_roles.includes(4) || _roles.includes(5) || _roles.includes(1) || _roles.includes(46)) && <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />}
            {(_roles.includes(4) || _roles.includes(5) || _roles.includes(1) || _roles.includes(46)) && <JVDropdown column={6} label="Branch" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />}
            <div style={{ margin: '10px 0', width: '100%' }}></div>
            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyPrimeVendorPerformanceReports); }} type="button"></Button>
            </div>
        </form>
    );
}
